"use strict";
exports.__esModule = true;
exports.hasIntercom = void 0;
var hasIntercom = function () {
    return typeof window !== "undefined" && window.Intercom;
};
exports.hasIntercom = hasIntercom;
//# sourceMappingURL=has-intercom.js.map